export const JOB_SEARCH_STATE = ['activelySearching', 'openOpportunities', 'dreamjobOnly', 'notSearching'];
